






























































































































import { Vue, Component, Mixins } from "vue-property-decorator";
import MyForm from "@/mixins/form";
import _ from "lodash";

@Component
export default class extends Mixins(MyForm) {
  data: any[] = [];

  formData: any = {
    setting_rule: [],
  };

  handleSubmit() {
    this.form.validateFields((err: any, values: any) => {
      if (!err) {
        this.showTsConfirm({
          title: "确认信息",
          content: "确定要提交吗？",
          onOk: async () => {
            this.confirmLoading = true;
            const res = await this.$store.dispatch("setting/add", values);
            if (res && res.Message === "success") {
              this.$message.success(res.Message);

              this.handleCancel();
            } else {
              this.$message.error(res.Message);
            }
            this.confirmLoading = false;
          },
        });
      }
    });
  }

  addRule(idx: number) {
    this.formData.setting_rule.push({
      name: "",
      value: "",
    });
  }

  removeRule(idx: number) {
    this.formData.setting_rule.splice(idx, 1);
  }
}
